export const SET_FRAGMENT = 'SET_FRAGMENT'
export const RESET_FRAGMENTS = 'RESET_FRAGMENTS'

// var fragment = { layer: 'Object', fragment: 'Object', data: 'Object' }
export const setFragment = fragment => ({
  type: SET_FRAGMENT,
  fragment
})

export const resetFragments = fragments => ({
  type: RESET_FRAGMENTS,
  fragments
})
